import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { SharepointComponent } from './shared/sharepoint/sharepoint.component';
import { fuelSaleGuard } from './portal/volumes/guards/fuel-sale.guard';
import { saleByIdGuard } from './portal/volumes/guards/sale-by-id.guard';
import { compassBiGuard } from './portal/volumes/guards/compass-bi.guard';
import { storeGuard } from './portal/store/guards/store.guard';
import { deviationManagementGuard } from './portal/deviation-management/guards/deviation-management.guard';
import { axionCardGuard } from './portal/axion-card/guard/axion-card.guard';
import { agroGuard } from './portal/agro/guard/agro.guard';
import { fuelOrderGuard } from './portal/orders/guards/fuel-order.guard';
import { marineOrderGuard } from './portal/orders/guards/marine-order.guard';
import UserDebugComponent from './debug/layout/user-debug/user-debug.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'portal' },
  {
    path: 'password-reset-success',
    loadComponent: () =>
      import('./shared/password-reset-success/password-reset-success.component').then(
        c => c.PasswordResetSuccessComponent,
      ),
  },
  {
    path: 'portal',
    loadComponent: () => import('./shared/dashboard/layout/layout.component').then(c => c.LayoutComponent),
    canActivate: [MsalGuard],
    children: [
      { path: 'home', loadComponent: () => import('./portal/home/home.component').then(c => c.HomeComponent) },
      {
        path: 'frequently-asked-questions',
        loadComponent: () =>
          import('./portal/frequently-asked-questions/frequently-asked-questions.component').then(
            c => c.FrequentlyAskedQuestionsComponent,
          ),
      },
      {
        path: 'account',
        loadComponent: () => import('./portal/my-account/my-account.component').then(c => c.MyAccountComponent),
      },
      {
        path: 'debin',
        loadComponent: () => import('./portal/my-account/debin/debin.component').then(c => c.DebinComponent),
      },
      {
        path: 'business-line',
        loadComponent: () =>
          import('./portal/my-account/debin/business-line/business-line.component').then(c => c.BusinessLineComponent),
      },
      {
        path: 'patents',
        loadComponent: () => import('./portal/patents/patents.component').then(c => c.PatentsComponent),
      },
      {
        path: 'messaging',
        loadComponent: () => import('./portal/messaging/messaging.component').then(c => c.MessagingComponent),
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import('./portal/terms-and-conditions/terms-and-conditions.component').then(
            c => c.TermsAndConditionsComponent,
          ),
      },
      {
        path: 'terms-and-conditions-historical',
        loadComponent: () =>
          import('./portal/terms-and-conditions/historical/historical.component').then(c => c.HistoricalComponent),
      },
      { path: 'orders', loadComponent: () => import('./portal/orders/orders.component').then(c => c.OrdersComponent) },
      {
        path: 'orders/fuels',
        loadComponent: () => import('./portal/orders/fuels/fuels.component').then(c => c.FuelsComponent),
        canActivate: [MsalGuard, fuelOrderGuard],
      },
      {
        path: 'orders/lubes',
        loadComponent: () => import('./portal/orders/lubes/lubes.component').then(c => c.LubesComponent),
      },
      {
        path: 'orders/edit',
        loadComponent: () =>
          import('./portal/orders/fuels/components/edit-order-fuel/form/edit-order-fuel.component').then(
            c => c.EditOrderFuelComponent,
          ),
      },
      {
        path: 'orders/edit-chemicals',
        loadComponent: () =>
          import('./portal/orders/quimicos/components/edit-order-chemicals/form/edit-order-chemicals.component').then(
            c => c.EditOrderChemicalsComponent,
          ),
      },
      {
        path: 'orders/edit-lubes',
        loadComponent: () =>
          import('./portal/orders/lubes/components/edit-order-lubes/edit-order-lubes.component').then(
            c => c.EditOrderLubesComponent,
          ),
      },
      {
        path: 'orders/chemicals',
        loadComponent: () => import('./portal/orders/quimicos/quimicos.component').then(c => c.QuimicosComponent),
      },
      {
        path: 'orders/resume',
        loadComponent: () =>
          import('./portal/orders/resume-orders/resume-orders.component').then(c => c.ResumeOrdersComponent),
      },
      {
        path: 'orders/resume-chemicals',
        loadComponent: () =>
          import('./portal/orders/resume-orders-quimicos/resume-orders-quimicos.component').then(
            c => c.ResumeOrdersQuimicosComponent,
          ),
      },
      {
        path: 'orders/resume-lubes',
        loadComponent: () =>
          import('./portal/orders/resume-orders-lubes/resume-orders-lubes.component').then(
            c => c.ResumeOrdersLubesComponent,
          ),
      },
      {
        path: 'quality',
        loadComponent: () => import('./portal/quality/quality-pages.component').then(c => c.QualityPagesComponent),
      },
      {
        path: 'quality/quality-fuels',
        loadComponent: () =>
          import('./portal/quality/quality-fuels/quality-fuels.component').then(c => c.QualityFuelsComponent),
      },
      {
        path: 'quality/reference-material',
        loadComponent: () =>
          import('./portal/quality/reference-material/reference-material.component').then(
            c => c.ReferenceMaterialComponent,
          ),
      },
      {
        path: 'quality/axion-lab',
        loadComponent: () => import('./portal/quality/axion-lab/axion-lab.component').then(c => c.AxionLabComponent),
      },
      {
        path: 'quality/water-measurement-in-tank',
        loadComponent: () =>
          import('./portal/quality/WaterMeasurementInTank/water-measurement-in-tank.component').then(
            c => c.WaterMeasurementInTankComponent,
          ),
      },
      {
        path: 'orders/turnos-carga',
        loadComponent: () =>
          import('./portal/orders/turnos-carga/turnos-carga.component').then(c => c.TurnosCargaComponent),
      },
      {
        path: 'orders/marine-bunker/order',
        loadComponent: () =>
          import('./portal/orders/marine-bunker/order-marine-bunker/order-marine-bunker.component').then(
            c => c.OrderMarineBunkerComponent,
          ),
        canActivate: [MsalGuard, marineOrderGuard],
      },
      {
        path: 'orders/marine-bunker/nomination-status',
        loadComponent: () =>
          import('./portal/orders/marine-bunker/nomination-status/nomination-status.component').then(
            c => c.NominationStatusComponent,
          ),
      },
      {
        path: 'orders/marine-bunker/create-nomination/ranch',
        loadComponent: () =>
          import('./portal/orders/marine-bunker/create-nomination/create-nomination.component').then(
            c => c.CreateNominationComponent,
          ),
        data: { description: 'RANCHO' },
      },
      {
        path: 'orders/marine-bunker/create-nomination/expo',
        loadComponent: () =>
          import('./portal/orders/marine-bunker/create-nomination/create-nomination.component').then(
            c => c.CreateNominationComponent,
          ),
        data: { description: 'GENERAL' },
      },
      {
        path: 'current-account',
        loadComponent: () =>
          import('./portal/current-account/current-account.component').then(c => c.CurrentAccountComponent),
        canActivate: [MsalGuard],
        children: [
          {
            path: 'account-statement',
            loadComponent: () =>
              import('./portal/current-account/account-statement/account-statement.component').then(
                c => c.AccountStatementComponent,
              ),
          },
          {
            path: 'reclassification',
            loadComponent: () =>
              import('./portal/current-account/reclassification/reclassification.component').then(
                c => c.ReclassificationComponent,
              ),
          },
          {
            path: 'administrative-positions',
            loadComponent: () =>
              import('./portal/current-account/administrative-positions/administrative-positions.component').then(
                c => c.AdministrativePositionsComponent,
              ),
          },
          {
            path: 'applied-transactions-and-paychecks',
            loadComponent: () =>
              import('./portal/current-account/applied-transactions-and-paychecks/applied-transactions-and-paychecks.component').then(
                c => c.AppliedTransactionsAndPaychecksComponent,
              ),
            children: [
              {
                path: 'applied-departures',
                loadComponent: () =>
                  import('./portal/current-account/applied-transactions-and-paychecks/applied-departures/applied-departures.component').then(
                    c => c.AppliedDeparturesComponent,
                  ),
              },
              {
                path: 'historial-checks',
                loadComponent: () =>
                  import('./portal/current-account/applied-transactions-and-paychecks/historial-checks/historial-checks.component').then(
                    c => c.HistorialChecksComponent,
                  ),
              },
            ],
          },
          {
            path: 'available-amount',
            loadComponent: () =>
              import('./portal/current-account/avail-amount/avail-amount.component').then(c => c.AvailAmountComponent),
          },
        ],
      },
      {
        path: 'taxes',
        loadComponent: () => import('./portal/taxes/taxes.component').then(c => c.TaxesComponent),
        canActivate: [MsalGuard],
      },
      {
        path: 'taxes/tax-situation',
        loadComponent: () =>
          import('./portal/taxes/tax-situation/tax-situation.component').then(c => c.TaxSituationComponent),
        canActivate: [MsalGuard],
      },
      {
        path: 'taxes/retention-certificates',
        loadComponent: () =>
          import('./portal/taxes/retention-certificates/retention-certificates.component').then(
            c => c.RetentionCertificatesComponent,
          ),
        canActivate: [MsalGuard],
      },
      {
        path: 'payments',
        loadComponent: () => import('./portal/payments/payments.component').then(c => c.PaymentsComponent),
        canActivate: [MsalGuard],
      },
      {
        path: 'payments/learn-payment-methods',
        loadComponent: () =>
          import('./portal/payments/learn-payment-methods/learn-payment-methods.component').then(
            c => c.LearnPaymentMethodsComponent,
          ),
        canActivate: [MsalGuard],
      },
      {
        path: 'payments/inform-payments',
        loadComponent: () =>
          import('./portal/payments/inform-payments/inform-payments.component').then(c => c.InformPaymentsComponent),
        canActivate: [MsalGuard],
      },
      {
        path: 'library',
        loadComponent: () => import('./portal/library/library.component').then(c => c.LibraryComponent),
      },
      {
        path: 'library/user-guides',
        loadComponent: () =>
          import('./portal/library/user-guides/user-guides.component').then(c => c.UserGuidesComponent),
      },
      {
        path: 'library/doc-interes',
        loadComponent: () =>
          import('./portal/library/doc-interes/doc-interes.component').then(c => c.DocInteresComponent),
      },
      { path: 'asr', loadComponent: () => import('./portal/asr/asr.component').then(c => c.AsrComponent) },
      {
        path: 'asr/sales',
        loadComponent: () => import('./portal/asr/sales/asr-sales.component').then(c => c.AsrSalesComponent),
      },
      {
        path: 'asr/inventories',
        loadComponent: () => import('./portal/asr/inventory/inventory.component').then(c => c.InventoryComponent),
      },
      {
        path: 'asr/provisions-sales',
        loadComponent: () =>
          import('./portal/asr/provisions-sales/provisions-sales.component').then(c => c.ProvisionsSalesComponent),
      },
      { path: 'hsa', loadComponent: () => import('./portal/hsa/hsa.component').then(c => c.HsaComponent) },
      {
        path: 'hsa/capacitations',
        loadComponent: () =>
          import('./portal/hsa/capacitations/capacitations.component').then(c => c.CapacitationsComponent),
      },
      {
        path: 'hsa/autoevaluation',
        loadComponent: () =>
          import('./portal/hsa/autoevaluation/autoevaluation.component').then(c => c.AutoevaluationComponent),
      },
      {
        path: 'hsa/autoevaluation/form/:questionnaireId',
        loadComponent: () =>
          import('./portal/hsa/autoevaluation/autoevaluation-form/autoevaluation-form.component').then(
            c => c.AutoevaluationFormComponent,
          ),
      },
      {
        path: 'marketing',
        loadComponent: () => import('./portal/marketing/marketing.component').then(c => c.MarketingComponent),
      },
      {
        path: 'marketing/brand-guidelines',
        loadComponent: () =>
          import('./portal/marketing/brandGuidelines/brand-guidelines.component').then(c => c.BrandGuidelinesComponent),
      },
      {
        path: 'marketing/campaign-assets',
        loadComponent: () =>
          import('./portal/marketing/campaignAssets/campaign-assets.component').then(c => c.CampaignAssetsComponent),
      },
      {
        path: 'marketing/social-network',
        loadComponent: () =>
          import('./portal/marketing/socialNetwork/social-network.component').then(c => c.SocialNetworkComponent),
      },
      {
        path: 'marketing/pos-materials',
        loadComponent: () =>
          import('./portal/marketing/pos-materials/pos-materials.component').then(c => c.PosMaterialsComponent),
      },
      {
        path: 'engineering-and-maintenance/indicators',
        loadComponent: () =>
          import('./portal/engineering-and-maintenance/indicators/indicators.component').then(
            c => c.IndicatorsComponent,
          ),
      },
      {
        path: 'engineering-and-maintenance',
        loadComponent: () =>
          import('./portal/engineering-and-maintenance/engineering-and-maintenance.component').then(
            c => c.EngineeringAndMaintenanceComponent,
          ),
      },
      {
        path: 'engineering-and-maintenance/capacitaciones-y-buenas-practicas',
        loadComponent: () =>
          import('./portal/engineering-and-maintenance/capacitaciones-y-buenas-practicas/capacitaciones-y-buenas-practicas.component').then(
            c => c.CapacitacionesYBuenasPracticasComponent,
          ),
      },
      {
        path: 'engineering-and-maintenance/mantenimiento-preventivo',
        loadComponent: () =>
          import('./portal/engineering-and-maintenance/mantenimiento-preventivo/mantenimiento-preventivo.component').then(
            c => c.MantenimientoPreventivoComponent,
          ),
      },
      {
        path: 'engineering-and-maintenance/procedimientos',
        loadComponent: () =>
          import('./portal/engineering-and-maintenance/procedimientos/procedimientos.component').then(
            c => c.ProcedimientosComponent,
          ),
      },
      {
        path: 'engineering-and-maintenance/comunicados-novedades',
        loadComponent: () =>
          import('./portal/engineering-and-maintenance/comunicados-novedades/comunicados-novedades.component').then(
            c => c.ComunicadosNovedadesComponent,
          ),
      },
      {
        path: 'customer-experience',
        loadComponent: () =>
          import('./portal/customer-experience/customer-experience.component').then(c => c.CustomerExperienceComponent),
      },
      {
        path: 'customer-experience/full-dashboard',
        loadComponent: () =>
          import('./portal/customer-experience/full-dashboard/full-dashboard.component').then(
            c => c.FullDashboardComponent,
          ),
      },
      {
        path: 'castrol/impulso-castrol',
        loadComponent: () =>
          import('./portal/castrol/impulso-castrol/impulso-castrol.component').then(c => c.ImpulsoCastrolComponent),
      },
      {
        path: 'customer-experience/google-reviews',
        loadComponent: () =>
          import('./portal/customer-experience/google-reviews/google-reviews.component').then(
            c => c.GoogleReviewsComponent,
          ),
      },
      {
        path: 'on-program',
        loadComponent: () => import('./portal/on-program/on-program.component').then(c => c.OnProgramComponent),
      },
      {
        path: 'on-program/on-my-station',
        loadComponent: () =>
          import('./portal/on-program/on-my-station/on-my-station.component').then(c => c.OnMyStationComponent),
      },
      {
        path: 'on-program/monthly-report',
        loadComponent: () =>
          import('./portal/on-program/monthly-report/monthly-report.component').then(c => c.MonthlyReportComponent),
      },
      {
        path: 'commercial-training',
        loadComponent: () =>
          import('./portal/commercial-training/commercial-training.component').then(c => c.CommercialTrainingComponent),
      },
      {
        path: 'documents',
        loadComponent: () => import('./shared/sharepoint/sharepoint.component').then(c => c.SharepointComponent),
        canDeactivate: [(component: SharepointComponent) => component.canDeactivate()],
      },
      {
        path: 'volumes',
        loadComponent: () => import('./portal/volumes/volumes.component').then(c => c.VolumesComponent),
      },
      {
        path: 'volumes/fuel-purchase',
        loadComponent: () =>
          import('./portal/volumes/fuel-purchase/fuel-purchase.component').then(c => c.FuelPurchaseComponent),
        canActivate: [MsalGuard],
      },
      {
        path: 'volumes/fuel-sale',
        loadComponent: () => import('./portal/volumes/fuel-sale/fuel-sale.component').then(c => c.FuelSaleComponent),
        canActivate: [MsalGuard, fuelSaleGuard],
      },
      {
        path: 'volumes/fuel-sale/bi',
        loadComponent: () =>
          import('./portal/volumes/fuel-sale/fuel-sale-bi/fuel-sale-bi.component').then(c => c.FuelSaleBiComponent),
        canActivate: [MsalGuard, fuelSaleGuard],
      },
      {
        path: 'volumes/sale-by-id',
        loadComponent: () => import('./portal/volumes/sale-by-id/sale-by-id.component').then(c => c.SaleByIdComponent),
        canActivate: [MsalGuard, saleByIdGuard],
      },
      {
        path: 'volumes/compass-bi',
        loadComponent: () => import('./portal/volumes/compass-bi/compass-bi.component').then(c => c.CompassBiComponent),
        canActivate: [MsalGuard, compassBiGuard],
      },
      {
        path: 'store',
        loadComponent: () => import('./portal/store/store.component').then(c => c.StoreComponent),
        canActivate: [MsalGuard, storeGuard],
        children: [
          { path: '', redirectTo: 'releases-and-promotions', pathMatch: 'full' },
          {
            path: 'releases-and-promotions',
            loadComponent: () =>
              import('./portal/store/releases-and-promotions/releases-and-promotions.component').then(
                c => c.ReleasesAndPromotionsComponent,
              ),
          },
          {
            path: 'manuals',
            loadComponent: () => import('./portal/store/manuals/manuals.component').then(c => c.ManualsComponent),
          },
          {
            path: 'planograms',
            loadComponent: () =>
              import('./portal/store/planograms/planograms.component').then(c => c.PlanogramsComponent),
          },
          {
            path: 'costs-and-suggested-prices',
            loadComponent: () =>
              import('./portal/store/costs-and-suggested-prices/costs-and-suggested-prices.component').then(
                c => c.CostsAndSuggestedPricesComponent,
              ),
          },
          {
            path: 'sworn-statement',
            loadComponent: () =>
              import('./portal/store/sworn-statement/sworn-statement.component').then(c => c.SwornStatementComponent),
            children: [
              {
                path: 'store',
                loadComponent: () =>
                  import('./portal/store/sworn-statement/sworn-statement-list/sworn-statement-list.component').then(
                    c => c.SwornStatementListComponent,
                  ),
                data: { type: 'store' },
              },
              {
                path: 'sandwich-stand',
                loadComponent: () =>
                  import('./portal/store/sworn-statement/sworn-statement-list/sworn-statement-list.component').then(
                    c => c.SwornStatementListComponent,
                  ),
                data: { type: 'sandwich-stand' },
              },
            ],
          },
          {
            path: 'sanwich-satandar',
            loadComponent: () =>
              import('./portal/store/parada-sanguchera/parada-sanguchera.component').then(
                c => c.ParadaSangucheraComponent,
              ),
          },
          {
            path: 'sanwich-express',
            loadComponent: () =>
              import('./portal/store/parada-sanguchera-express/parada-sanguchera-express.component').then(
                c => c.ParadaSangucheraExpressComponent,
              ),
          },
          {
            path: 'marketplace',
            loadComponent: () =>
              import('./portal/store/marketplace/marketplace.component').then(c => c.MarketplaceComponent),
          },
        ],
      },
      {
        path: 'store/marketplace-report',
        loadComponent: () =>
          import('./portal/store/marketplace/marketplace-report/marketplace-report.component').then(
            c => c.MarketplaceReportComponent,
          ),
      },
      {
        path: 'store/points-of-interest',
        loadComponent: () =>
          import('./portal/store/points-of-interest/points-of-interest.component').then(
            c => c.PointsOfInterestComponent,
          ),
        canActivate: [MsalGuard, storeGuard],
      },
      {
        path: 'store/contact-with-us',
        loadComponent: () =>
          import('./portal/store/contact-with-us/contact-with-us.component').then(c => c.ContactWithUsComponent),
        canActivate: [MsalGuard, storeGuard],
      },
      {
        path: 'store/sworn-statement-form/store',
        loadComponent: () =>
          import('./portal/store/sworn-statement/sworn-statement-form/sworn-statement-form.component').then(
            c => c.SwornStatementFormComponent,
          ),
        canActivate: [MsalGuard, storeGuard],
        data: { type: 'store' },
      },
      {
        path: 'store/sworn-statement-form/sandwich-stand',
        loadComponent: () =>
          import('./portal/store/sworn-statement/sworn-statement-form/sworn-statement-form.component').then(
            c => c.SwornStatementFormComponent,
          ),
        canActivate: [MsalGuard, storeGuard],
        data: { type: 'sandwich-stand' },
      },
      {
        path: 'operations-management',
        loadComponent: () =>
          import('./portal/operations-management/operations-management.component').then(
            c => c.OperationsManagementComponent,
          ),
      },
      {
        path: 'operations-management/manuals',
        loadComponent: () =>
          import('./portal/operations-management/operations-manuals/operations-manuals.component').then(
            c => c.OperationsManualsComponent,
          ),
      },
      {
        path: 'operations-management/benefits',
        loadComponent: () =>
          import('./portal/operations-management/benefits/benefits.component').then(c => c.BenefitsComponent),
      },
      {
        path: 'operations-management/opportunities',
        loadComponent: () =>
          import('./portal/operations-management/opportunities/opportunities.component').then(
            c => c.OpportunitiesComponent,
          ),
      },
      {
        path: 'operations-management/client-experience',
        loadComponent: () =>
          import('./portal/operations-management/client-experience/client-experience.component').then(
            c => c.ClientExperienceComponent,
          ),
      },
      {
        path: 'operations-management/red-axion-evaluation',
        loadComponent: () =>
          import('./portal/operations-management/red-axion-evaluation/red-axion-evaluation.component').then(
            c => c.RedAxionEvaluationComponent,
          ),
      },
      {
        path: 'operations-management/mystery-shopper',
        loadComponent: () =>
          import('./portal/operations-management/mystery-shopper/mystery-shopper.component').then(
            c => c.MysteryShopperComponent,
          ),
      },
      {
        path: 'operations-management/incentive-contests',
        loadComponent: () =>
          import('./portal/operations-management/incentive-contests/incentive-contests.component').then(
            c => c.IncentiveContestsComponent,
          ),
      },
      {
        path: 'operations-management/incentive-contests/generic-section/:id',
        loadComponent: () =>
          import('./portal/operations-management/incentive-contests/generic-section/generic-section.component').then(
            c => c.GenericSectionComponent,
          ),
      },
      {
        path: 'ticketera',
        loadComponent: () =>
          import('./portal/ticketera/ticketera-page/ticketera-page.component').then(c => c.TicketeraPageComponent),
        canActivate: [MsalGuard],
      },
      {
        path: 'axion-card',
        loadComponent: () => import('./portal/axion-card/axion-card.component').then(c => c.AxionCardComponent),
        canActivate: [MsalGuard, axionCardGuard],
      },
      {
        path: 'axion-card/transactions-report',
        loadComponent: () =>
          import('./portal/axion-card/transactions-report/transactions-report.component').then(
            c => c.TransactionsReportComponent,
          ),
        canActivate: [MsalGuard, axionCardGuard],
      },
      {
        path: 'axion-card/consume-volumes',
        loadComponent: () =>
          import('./portal/axion-card/consume-volumes/consume-volumes.component').then(c => c.ConsumeVolumesComponent),
        canActivate: [MsalGuard, axionCardGuard],
      },
      {
        path: 'axion-card/refered-program',
        loadComponent: () =>
          import('./portal/axion-card/refered-program/refered-program.component').then(c => c.ReferedProgramComponent),
        canActivate: [MsalGuard, axionCardGuard],
      },
      {
        path: 'axion-card/aditional-documents',
        loadComponent: () =>
          import('./portal/axion-card/aditional-documents/aditional-documents.component').then(
            c => c.AditionalDocumentsComponent,
          ),
        canActivate: [MsalGuard, axionCardGuard],
      },
      {
        path: 'agro',
        canActivateChild: [agroGuard],
        children: [
          { path: '', loadComponent: () => import('./portal/agro/agro.component').then(c => c.AgroComponent) },
          {
            path: 'agroReport',
            loadComponent: () =>
              import('./portal/agro/agro-challenge/agro-challenge.component').then(c => c.AgroChallengeComponent),
          },
          {
            path: 'agroView',
            loadComponent: () => import('./portal/agro/agro-view/agro-view.component').then(c => c.AgroViewComponent),
          },
        ],
      },
      {
        path: 'gestion-desvios',
        loadComponent: () =>
          import('./portal/deviation-management/deviation-management.component').then(
            c => c.DeviationManagementComponent,
          ),
        canActivate: [MsalGuard, deviationManagementGuard],
      },
      {
        path: 'castrol',
        loadComponent: () => import('./portal/castrol/castrol.component').then(c => c.CastrolComponent),
        canActivate: [MsalGuard],
      },
      { path: '**', redirectTo: 'home' },
    ],
  },
  {
    path: 'user-debug',
    component: UserDebugComponent,
    canActivate: [MsalGuard],
  },
  { path: '**', redirectTo: 'portal' },
];
